import { render, staticRenderFns } from "./EmployeePersonal.vue?vue&type=template&id=131e40ea&scoped=true"
import script from "./EmployeePersonal.vue?vue&type=script&lang=js"
export * from "./EmployeePersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131e40ea",
  null
  
)

export default component.exports